import { useUserAccounts } from '@features/accounts';
import { Skeleton, Text } from '@radix-ui/themes';

interface HistoryAuthorLabelProps {
    userId: string;
}

export const HistoryAuthorLabel = ({ userId }: HistoryAuthorLabelProps) => {
    const { data, isFetching } = useUserAccounts({}, { userId });

    if (isFetching) {
        return (
            <Skeleton>
                <Text size='2' weight='medium'>
                    Loading...
                </Text>
            </Skeleton>
        );
    }

    const personalAccount = data.find((acc) => acc.isPersonal);
    const displayName = personalAccount?.ownerUsername || `User ${userId}`;

    return (
        <Text size='2' weight='medium'>
            {displayName}
        </Text>
    );
};
